import { Suspense } from "react";
import { useLocation } from "react-router";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Toaster } from "sonner";
import { lazyWithRetry } from "@/lib/lazy-with-retry";
import { AuthProvider } from "@/contexts/auth.provider";
import { MessagingProvider } from "@/contexts/messaging.provider";
import { ErrorBoundary } from "./ErrorBoundary";
import { TooltipProvider } from "./ui/tooltip";
import { useReferralCapture } from "@/hooks/use-referral-capture";
import { isChromelessPath } from "@/lib/urls";

const FloatingAIAssistant = lazyWithRetry(
  () => import("./FloatingAIAssistant"),
);

/** Immersive full-page flows render without the app chrome. */
const Layout = ({ children }: { children: React.ReactNode }) => {
  useReferralCapture();
  const { pathname } = useLocation();
  const chromeless = isChromelessPath(pathname);

  return (
    <AuthProvider>
      <MessagingProvider>
        <div className="flex flex-col min-h-screen">
          {!chromeless && <Navbar />}
          <main className="grow w-full">
            <ErrorBoundary>
              <TooltipProvider>{children}</TooltipProvider>
            </ErrorBoundary>
            <Toaster />
          </main>
          {!chromeless && <Footer />}
          {!chromeless && (
            <Suspense fallback={null}>
              <FloatingAIAssistant />
            </Suspense>
          )}
        </div>
      </MessagingProvider>
    </AuthProvider>
  );
};

export default Layout;
